import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CarrierOption, CarrierRecommendation, Listing, PlanInput, PlanPreview, ShipmentPlan, ShipmentRow, SiteOption, TripPlanBatch, TripRow, TripDetails, TripMetadataInput, ShipmentMetadataInput } from './planning.models';

@Injectable({ providedIn: 'root' })
export class ShipmentPlanningService {
  private readonly endpoint = '/api/shipments/planning.php';
  constructor(private readonly http: HttpClient) {}
  listTrips(query: Record<string, string>): Observable<Listing<TripRow>> { return this.get('trips', query); }
  listShipments(query: Record<string, string>): Observable<Listing<ShipmentRow>> { return this.get('shipments', query); }
  plan(uuid: string): Observable<ShipmentPlan> { return this.get('plan', { uuid }); }
  tripPlan(uuid: string, offset: number): Observable<TripPlanBatch> { return this.get('trip_plan', { uuid, offset: String(offset) }); }
  tripDetails(uuid: string): Observable<TripDetails> { return this.get('trip_details', { uuid }); }
  saveTripMetadata(uuid: string, input: TripMetadataInput): Observable<{ ok: boolean }> {
    return this.http.put<{ ok: boolean }>(this.endpoint, input, { params: { action: 'trip_metadata', uuid } });
  }
  saveShipmentMetadata(uuid: string, input: ShipmentMetadataInput): Observable<{ ok: boolean }> {
    return this.http.put<{ ok: boolean }>(this.endpoint, input, { params: { action: 'shipment_metadata', uuid } });
  }
  sites(q: string): Observable<{ data: SiteOption[] }> { return this.get('options', { kind: 'site', q }); }
  carriers(q: string): Observable<{ data: CarrierOption[] }> { return this.get('options', { kind: 'carrier', q }); }
  carrierOptions(uuid: string, source_version: string, role: string, date: string, terminal: SiteOption | null): Observable<CarrierRecommendation> {
    return this.get('carrier_options', { uuid, source_version, role, date,
      ...(terminal ? { terminal_contact: terminal.contact_uuid, terminal_address: terminal.address_uuid } : {}) });
  }
  preview(uuid: string, input: PlanInput): Observable<PlanPreview> {
    return this.http.post<PlanPreview>(this.endpoint, input, { params: { action: 'preview', uuid } });
  }
  private get<T>(action: string, query: Record<string, string>): Observable<T> {
    return this.http.get<T>(this.endpoint, { params: new HttpParams({ fromObject: { action, ...query } }) });
  }
}
